import { useEffect } from "react";

export default function useMatchInputToChoices(
	currentInput,
	choices,
	onInputChange,
) {
	useEffect(() => {
		if (!choices || currentInput.isEmpty()) {
			return;
		}

		const hasValidInput = currentInput.every((input) =>
			choices.find((choice) => choice.key === input),
		);

		if (hasValidInput) {
			return;
		}

		const newInput = currentInput.filter((input) =>
			choices.find((choice) => choice.key === input),
		);
		onInputChange(newInput);
	}, [choices]);
}
